import React, { useState } from "react";
import { Button, Modal, Row, Col, Divider, Form, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
// component
import BankHolderName from "./component/bank_name";
import BankNumber from "./component/bank_number";
//redux
import { addBank, addBankToAccount, getAccount } from "../../../store/stripe/stripe.action";
import { accountSelector } from "../../../store/stripe/stripe.selector";
//

const BranchBankDialog = (props) => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const dialog = props?.dialog;
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const account = useSelector(accountSelector);
  const stripeAccount = account?.id;
  // -------------------------- FUNCTION --------------------------

  const onFinish = (values) => {
    setLoading(true);
    dispatch(
      addBank({ bank: values }, (response) => {
        if (response.status === 200) {
          const externalAccount = response?.data?.id;
          handleBank({ externalAccount });
        } else {
          const error = response?.data?.raw?.message;
          setLoading(false);
          message.error(error);
        }
      })
    );
  };

  const handleBank = ({ externalAccount }) => {
    console.log({ stripeAccount, externalAccount });
    dispatch(
      addBankToAccount({ stripeAccount, externalAccount }, () => {
        dispatch(getAccount({ id: stripeAccount }));
        setLoading(false);
        props.onClose();
      })
    );
  };

  const afterClose = () => {
    form.resetFields();
  };

  const handleClose = () => {
    props.onClose();
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Form
        name="bank_form"
        autoComplete="off"
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Row gutter={[16, 0]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BankHolderName />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <BankNumber />
          </Col>
          <Divider />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderButtons()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderButtons = () => {
    return (
      <Row gutter={[10, 10]} justify="space-between" align="center">
        <Col>{renderCancel()}</Col>
        <Col>{renderConfirm()}</Col>
      </Row>
    );
  };

  const renderCancel = () => {
    return (
      <Button key="back" onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
    );
  };

  const renderConfirm = () => {
    return (
      <Button type="primary" htmlType="submit" loading={loading}>
        Add Bank
      </Button>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title="Add Bank"
      visible={dialog}
      onCancel={handleClose}
      footer={null}
      destroyOnClose={true}
      afterClose={afterClose}
    >
      {renderBody()}
    </Modal>
  );
};

export default BranchBankDialog;
